module.exports = __webpack_public_path__ + "static/media/Baslik.1eb9bdd3.png";